const DEVICE_ID_STORAGE_KEY = 'mapleos-license-device-id';

function getBrowserName(userAgent: string) {
  if (/edg/i.test(userAgent)) return 'Edge';
  if (/chrome|crios/i.test(userAgent)) return 'Chrome';
  if (/firefox|fxios/i.test(userAgent)) return 'Firefox';
  if (/safari/i.test(userAgent) && !/chrome|crios|android/i.test(userAgent)) return 'Safari';
  return 'Browser';
}

function getPlatformName(platform: string, userAgent: string) {
  const value = `${platform} ${userAgent}`.toLowerCase();

  if (value.includes('win')) return 'Windows';
  if (value.includes('mac')) return 'macOS';
  if (value.includes('iphone') || value.includes('ipad') || value.includes('ios')) return 'iOS';
  if (value.includes('android')) return 'Android';
  if (value.includes('linux')) return 'Linux';

  return 'Device';
}

function getPersistentDeviceId() {
  const existing = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const next = typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, next);
  return next;
}

async function sha256(value: string) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function getLicenseDeviceIdentity() {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const browserName = getBrowserName(userAgent);
  const platformName = getPlatformName(platform, userAgent);
  const persistentDeviceId = getPersistentDeviceId();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown';
  const language = window.navigator.language || 'unknown';

  const fingerprint = await sha256([
    persistentDeviceId,
    userAgent,
    platform,
    timezone,
    language,
  ].join('|'));

  return {
    deviceFingerprint: fingerprint,
    deviceName: `${platformName} · ${browserName}`,
  };
}
